module.exports = __webpack_public_path__ + "static/media/coding-100.cd536a7b.jpg";